<div class="contents">
  <app-back-button></app-back-button>
  <div class="custom-modal-layout">
    <div class="modal-header" style="margin-bottom: 10px !important">
      <div class="icon">
        <img src="icons/plus-circle.svg" alt="Email Icon" />
      </div>
      <div class="d-flex">
        <span class="title">Cadastro de Auxílio de Formação</span>
        <!-- <ng-template *ngIf="bolseiro" pTemplate="content">
          <span class="subtitle">Estudante: {{bolseiro.nome}}</span>
          <span class="subtitle">{{bolseiro.numeroBI}}</span>
        </ng-template> -->
      </div>
    </div>
    <form
      class="container basis-[50rem] bg-white d-flex flex-column justify-content-center align-center"
      style="align-items: end"
      (ngSubmit)="save()"
    >
      <div
        class="row-identidade col-12 basis-[50rem] container p-fluid grid"
        *ngIf="f.nome.value && f.numeroBI.value"
      >
        <div class="card-identidade">
          <span class="label-identidade">Número do Bilhete de Identidade</span>
          <span class="value-identidade"
            ><b>{{ f.numeroBI.value }}</b></span
          >
        </div>
        <div class="card-identidade">
          <span class="label-identidade">Nome</span>
          <span class="value-identidade"
            ><b>{{ f.nome.value }}</b></span
          >
        </div>
      </div>

      <p-stepper [(value)]="activeStep" class="basis-[50rem] w-full">
        <p-step-list>
          <p-step [value]="1">
            <ng-template #content>
              <a
                class="step-indicator"
                [class.active]="activeStep === 1"
                (click)="activateCallback(1)"
              >
                <div class="number">1</div>
                <div class="label">Auxílio de Formação</div>
              </a>
            </ng-template>
          </p-step>
          <p-step [value]="2">
            <ng-template #content>
              <a
                class="step-indicator"
                [class.active]="activeStep === 2"
                (click)="activateCallback(2)"
              >
                <div class="number">2</div>
                <div class="label">Fases da Formação</div>
              </a>
            </ng-template>
          </p-step>
          <!-- <p-step [value]="3">
            <ng-template #content>
              <a class="step-indicator" [class.active]="activeStep === 3" (click)="activateCallback(3)">
                <div class="number">3</div>
                <div class="label">Dados Financeiros</div>
              </a>
            </ng-template>
          </p-step> -->
        </p-step-list>
        <p-step-panels>
          <div class="bg-white p-3">
            <p-step-panel [value]="1">
              <ng-template #content>
                <form [formGroup]="aidForm">
                  <div class="p-fluid grid">
                    <div class="field col-6">
                      <label for="programaFormacao">Acordo de Formação</label>
                      <p-select
                        id="programaFormacao"
                        class="w-full"
                        [filter]="true"
                        [options]="programaFormacaoOptions"
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="Seleccione o acordo de formação"
                        formControlName="programaFormacaoID"
                        [showClear]="true"
                        appendTo="body"
                      />
                      <div
                        *ngIf="
                          aidForm.get('programaFormacaoID')?.touched &&
                          aidForm.get('programaFormacaoID')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('programaFormacaoID')?.errors?.[
                              'required'
                            ]
                          "
                          >Acordo de Formação é obrigatório.</small
                        >
                      </div>
                    </div>

                    <div class="field col-6">
                      <label for="tipoBolsa">Tipo de Bolsa</label>
                      <p-select
                        id="tipoBolsa"
                        class="w-full"
                        [filter]="true"
                        [options]="tipoBolsaOptions"
                        optionLabel="designacao"
                        optionValue="id"
                        placeholder="Seleccione o tipo de bolsa"
                        formControlName="tipoBolsa"
                        [showClear]="true"
                        appendTo="body"
                      />
                      <div
                        *ngIf="
                          aidForm.get('tipoBolsa')?.touched &&
                          aidForm.get('tipoBolsa')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="aidForm.get('tipoBolsa')?.errors?.['required']"
                          >Tipo de Bolsa é obrigatório.</small
                        >
                      </div>
                    </div>
                    <!-- <pre>{{countries | json}}</pre> -->
                    <div class="field col-6">
                      <label for="paisestudo">País de Estudo</label>
                      <p-select
                        id="pais"
                        [filter]="true"
                        class="w-full"
                        [options]="countries"
                        optionLabel="designacao"
                        optionValue="id"
                        placeholder="Seleccione o país de estudo"
                        formControlName="paisID"
                      />
                      <div
                        *ngIf="
                          aidForm.get('paisID')?.touched &&
                          aidForm.get('tipoPepaisIDdidoID')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="aidForm.get('paisID')?.errors?.['required']"
                          >País de Estudo é obrigatório.</small
                        >
                      </div>
                    </div>

                    <div class="field col-6">
                      <label for="empresaGestora">Empresa Gestora</label>
                      <p-select
                        id="empresaGestora"
                        class="w-full"
                        [filter]="true"
                        [options]="empresaGestoraOptions"
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="Seleccione a empresa gestora"
                        formControlName="instituicaoGestoraID"
                        [showClear]="true"
                        appendTo="body"
                      />
                      <div
                        *ngIf="
                          aidForm.get('instituicaoGestoraID')?.touched &&
                          aidForm.get('instituicaoGestoraID')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('instituicaoGestoraID')?.errors?.[
                              'required'
                            ]
                          "
                          >Empresa Gestora é obrigatória.</small
                        >
                      </div>
                    </div>
                    <!-- <div class="field col-6">
                      <label for="areaFormacao">Área de Conhecimento</label>
                      <p-dropdown [filter]="true" appendTo="body" id="areaFormacao" [options]="areaProgramaFormacaoList"
                        optionLabel="designacao" optionValue="id" placeholder="Seleccione uma Área de Conhecimento"
                        class="w-full" formControlName="areaProgramaFormacaoID" [showClear]="true"
                        appendTo="body"></p-dropdown>
                      <div
                        *ngIf="aidForm.get('areaProgramaFormacaoID')?.touched && aidForm.get('areaProgramaFormacaoID')?.invalid">
                        <small class="error-message"
                          *ngIf="aidForm.get('areaProgramaFormacaoID')?.errors?.['required']">Área de Conhecimentoo é
                          obrigatório.</small>
                      </div>
                    </div> -->
                    <!-- <div class="field col-6">
                    <label for="areaProgramaFormacao">Área Programa de Formação</label>
                    <p-dropdown [filter]="true" appendTo="body" id="areaProgramaFormacao"
                      formControlName="areaProgramaFormacaoID" [options]="areaProgramaFormacaoList"
                      optionLabel="designacao" optionValue="id" placeholder="Seleccione um programa de formação"
                      class="w-full" [showClear]="true" appendTo="body"></p-dropdown>
                    <div *ngIf="aidForm.get('areaProgramaFormacaoID')?.touched && aidForm.get('areaProgramaFormacaoID')?.invalid">
                      <small class="error-message" *ngIf="aidForm.get('areaProgramaFormacaoID')?.errors?.['required']">Área Programa de Formação é obrigatória.</small>
                    </div>
                  </div> -->
                    <div class="field col-6">
                      <label for="nivelAcademico"
                        >Nível Académico Auxilio de Formação</label
                      >
                      <p-select
                        id="nivelAcademico"
                        class="w-full"
                        [filter]="true"
                        [options]="nivelAcademicoOptions"
                        optionLabel="label"
                        optionValue="id"
                        placeholder="Seleccione o nível Académico"
                        formControlName="nivelAcademico"
                        [showClear]="true"
                        appendTo="body"
                      />
                      <div
                        *ngIf="
                          aidForm.get('nivelAcademico')?.touched &&
                          aidForm.get('nivelAcademico')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('nivelAcademico')?.errors?.['required']
                          "
                          >Nível Académico é obrigatório.</small
                        >
                      </div>
                    </div>

                    <div class="field col-6">
                      <label for="categoria">Tipo de Estudante</label>
                      <p-select
                        id="categoria"
                        class="w-full"
                        [filter]="true"
                        [options]="categoriaOptions"
                        optionLabel="designacao"
                        optionValue="id"
                        placeholder="Seleccione o tipo de estudante"
                        formControlName="perfilEstudante"
                        [showClear]="true"
                        appendTo="body"
                      />
                      <div
                        *ngIf="
                          aidForm.get('perfilEstudante')?.touched &&
                          aidForm.get('perfilEstudante')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('perfilEstudante')?.errors?.['required']
                          "
                          >Perfil do Estudante é obrigatório.</small
                        >
                      </div>
                    </div>

                    <div class="field col-6">
                      <label for="dataInicio"
                        >Ano de Início Previsto do Auxílio de Formação</label
                      >
                      <p-datepicker
                        appendTo="body"
                        id="dataInicio"
                        class="w-full d-grid"
                        [showIcon]="true"
                        dateFormat="yy"
                        placeholder="Ano de Início"
                        formControlName="dataInicio"
                        [view]="'year'"
                        [yearNavigator]="true"
                        [maxDate]="maxDate"
                        [yearRange]="yearRange"
                      >
                      </p-datepicker>

                      <div
                        *ngIf="
                          aidForm.get('dataInicio')?.touched &&
                          aidForm.get('dataInicio')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('dataInicio')?.errors?.['required']
                          "
                        >
                          Ano de Início é obrigatório.
                        </small>
                      </div>
                    </div>

                    <div class="field col-6">
                      <label for="dataFim"
                        >Ano de Fim Previsto do Auxílio de Formação</label
                      >
                      <p-datepicker
                        appendTo="body"
                        id="dataFim"
                        class="w-full d-grid"
                        [showIcon]="true"
                        view="year"
                        dateFormat="yy"
                        placeholder="Ano de Fim"
                        formControlName="dataFim"
                        [view]="'year'"
                        [yearNavigator]="true"
                        [maxDate]="maxDate"
                        [yearRange]="yearRange"
                      ></p-datepicker>
                      <div
                        *ngIf="
                          aidForm.get('dataFim')?.touched &&
                          aidForm.get('dataFim')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="aidForm.get('dataFim')?.errors?.['required']"
                          >Ano de Fim é obrigatória.</small
                        >
                      </div>
                      <div
                        *ngIf="
                          aidForm.hasError('dataInicioFimRange') &&
                          aidForm.get('dataFim')?.dirty
                        "
                        class="error-message"
                      >
                        O ano de início deve ser inferior ao ano de fim
                      </div>
                    </div>

                    <article class="inst-learn col-12 mt-4">
                      <h5>Detalhes do Pedido</h5>
                      <span></span>
                    </article>
                    <div
                      class="d-flex align-items-center justify-content-between w-full m-0 p-0"
                    >
                      <div class="field col-6">
                        <label for="tipoPedido">Tipo de Pedido</label>
                        <p-select
                          id="tipoPedido"
                          class="w-full"
                          [filter]="true"
                          [options]="tipoPedidoOptions"
                          optionLabel="designacao"
                          optionValue="id"
                          placeholder="Seleccione o tipo de pedido"
                          formControlName="tipoPedidoID"
                          [showClear]="true"
                          appendTo="body"
                        />
                        <div
                          *ngIf="
                            aidForm.get('tipoPedidoID')?.touched &&
                            aidForm.get('tipoPedidoID')?.invalid
                          "
                        >
                          <small
                            class="error-message"
                            *ngIf="
                              aidForm.get('tipoPedidoID')?.errors?.['required']
                            "
                            >Tipo de Pedido é obrigatório.</small
                          >
                        </div>
                      </div>
                      <div class="field col-6">
                        <label for="nifRequerente">BI do Requerente*</label>
                        <div class="flex align-items-center relative">
                          <input
                            id="nifRequerente"
                            type="search"
                            class="w-full"
                            pInputText
                            formControlName="nifRequerente"
                            placeholder="Informe o número do BI do requerente"
                          />
                          <button
                            pButton
                            type="button"
                            icon="pi pi-search"
                            class="search-btn"
                            aria-label="Search"
                            (click)="searchDocumentNumberRequerente()"
                            [disabled]="aidForm.get('nifRequerente')?.invalid"
                          ></button>
                        </div>
                        <div
                          *ngIf="
                            aidForm.get('nifRequerente')?.touched &&
                            aidForm.get('nifRequerente')?.invalid
                          "
                        >
                          <small
                            class="error-message"
                            *ngIf="
                              aidForm.get('nifRequerente')?.errors?.['required']
                            "
                            >Número do Bilhete de Identidade do Requerente é
                            obrigatório.</small
                          >
                        </div>
                      </div>
                    </div>
                    <div class="field col-6">
                      <label for="nomeRequerente">Nome do Requerente</label>
                      <input
                        id="nomeRequerente"
                        type="text"
                        class="w-full"
                        pInputText
                        formControlName="nomeRequerente"
                        placeholder="Nome do requerente"
                      />
                      <div
                        *ngIf="
                          aidForm.get('nomeRequerente')?.touched &&
                          aidForm.get('nomeRequerente')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('nomeRequerente')?.errors?.['required']
                          "
                          >Nome do Requerente é obrigatório.</small
                        >
                      </div>
                    </div>
                    <div class="field col-6">
                      <label for="emailRequerente">E-mail do Requerente</label>
                      <input
                        id="emailRequerente"
                        type="email"
                        class="w-full"
                        pInputText
                        formControlName="emailRequerente"
                        placeholder="Email do requerente"
                      />
                      <div
                        *ngIf="
                          aidForm.get('emailRequerente')?.touched &&
                          aidForm.get('emailRequerente')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('emailRequerente')?.errors?.['required']
                          "
                          >E-mail do Requerente é obrigatório.</small
                        >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('emailRequerente')?.errors?.['email']
                          "
                          >E-mail inválido.</small
                        >
                      </div>
                    </div>
                    <div class="field col-6 d-flex flex-column">
                      <label for="telemovelRequerente"
                        >Telemóvel do Requerente</label
                      >
                      <p-inputmask
                        class="w-full d-contents"
                        id="telemovelRequerente"
                        mask="+244 999 999 999"
                        formControlName="telefoneRequerente"
                        placeholder="+244 999 999 000"
                      />
                      <div
                        *ngIf="
                          aidForm.get('telefoneRequerente')?.touched &&
                          aidForm.get('telefoneRequerente')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('telefoneRequerente')?.errors?.[
                              'required'
                            ]
                          "
                          >Telemóvel do Requerente é obrigatório.</small
                        >
                      </div>
                    </div>
                    <div class="field col-3">
                      <label for="dataPedido">Data do Pedido</label>
                      <p-datepicker
                        id="dataPedido"
                        class="w-full d-grid"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        placeholder="Seleccione a data do pedido"
                        formControlName="dataPedido"
                        [maxDate]="today"
                      ></p-datepicker>
                      <div
                        *ngIf="
                          aidForm.get('dataPedido')?.touched &&
                          aidForm.get('dataPedido')?.invalid
                        "
                      >
                        <small
                          class="error-message"
                          *ngIf="
                            aidForm.get('dataPedido')?.errors?.['required']
                          "
                          >Data do Pedido é obrigatória.</small
                        >
                      </div>
                      <!-- <div *ngIf="aidForm.hasError('dateRange') && aidForm.get('dataPedido')?.dirty" class="error-message">
                        Data do Pedido não pode ser anterior à data de Atribuição
                      </div> -->
                    </div>

                    <div class="field col-3">
                      <label for="dataAtribuicao">Data da Atribuição</label>
                      <p-datepicker
                        id="dataAtribuicao"
                        class="w-full d-grid"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        placeholder="Seleccione a data da atribuição"
                        formControlName="dataAtribuicao"
                        [maxDate]="today"
                      ></p-datepicker>
                      <div
                        *ngIf="
                          aidForm.get('dataAtribuicao')?.touched &&
                          aidForm.get('dataAtribuicao')?.invalid
                        "
                      >
                        <small
                          *ngIf="
                            aidForm.get('dataAtribuicao')?.errors?.['required']
                          "
                          class="error-message"
                          >Data da Atribuição é obrigatória.</small
                        >
                      </div>
                      <div
                        *ngIf="
                          aidForm.hasError('dataPedidoAtribuicaoRange') &&
                          aidForm.get('dataAtribuicao')?.dirty
                        "
                        class="error-message"
                      >
                        A data do pedido deve ser inferior à data de atribuição
                      </div>
                    </div>

                    <article class="inst-learn col-12 mt-4">
                      <h5>Encargos Financeiros</h5>
                      <span></span>
                    </article>

                    <!-- <div formArrayName="encargosFinanceiros">
                      <div *ngFor="let encargo of encargosFinanceirosForm.controls; let i = index" [formGroupName]="i"
                        class="grid">
                        <div class="field col-6 d-flex flex-column">
                          <label>Tipo de Subsídio</label>
                          <input type="text" class="w-full" pInputText formControlName="tipo" />
                        </div>
                        <div class="field col-3 d-flex flex-column">
                          <label>Valor</label>
                          <input type="number" class="w-full" pInputText formControlName="valor" />
                        </div>
                        <div class="field col-3 d-flex flex-column">
                          <label>Moeda</label>
                          <input type="text" class="w-full" pInputText formControlName="moeda" />
                        </div>
                      </div>
                    </div> -->

                    <div
                      formArrayName="encargosFinanceiros"
                      class="grid col-12 w-full"
                    >
                      <ng-container
                        *ngIf="
                          encargosFinanceirosForm.controls.length > 0;
                          else mensagemSelecao
                        "
                      >
                        <div
                          *ngFor="
                            let encargo of encargosFinanceirosForm.controls;
                            let i = index
                          "
                          [formGroupName]="i"
                          class="w-full grid m-0 p-0"
                        >
                          <div class="field col-6">
                            <label>Tipo de Subsídio</label>
                            <input
                              type="text"
                              class="w-full"
                              pInputText
                              formControlName="tipo"
                            />
                          </div>
                          <div class="field col-3">
                            <label>Valor</label>
                            <input
                              type="number"
                              class="w-full"
                              pInputText
                              formControlName="valor"
                            />
                          </div>
                          <div class="field col-3">
                            <label>Moeda</label>
                            <input
                              type="text"
                              class="w-full"
                              pInputText
                              formControlName="moeda"
                            />
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #mensagemSelecao>
                        <div class="d-flex col-12 justify-content-center">
                          <div
                            class="alert alert-info col-12 text-center"
                            style="margin-top: 1em"
                          >
                            Selecione o nível acadêmico e o perfil do estudante
                            para visualizar os encargos financeiros.
                          </div>
                        </div>
                      </ng-template>
                    </div>

                    <div
                      class="grid col-12 w-full"
                      *ngIf="
                        isExterna && aidForm.get('regraPagamentoID')?.value
                      "
                    >
                      <div class="field col-6 d-flex flex-column">
                        <label for="entidadeSeguradoraID"
                          >Entidade Seguradora</label
                        >
                        <p-select
                          id="entidadeSeguradoraID"
                          formControlName="entidadeSeguradoraID"
                          [options]="entidadesSeguradorasOptions"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione a seguradora"
                          appendTo="body"
                        >
                        </p-select>
                      </div>
                      <div class="field col-6 d-flex flex-column">
                        <label for="valorAnualSeguro">Valor Anual</label>
                        <input
                          id="valorAnualSeguro"
                          type="text"
                          class="w-full"
                          pInputText
                          formControlName="valorAnualSeguro"
                          placeholder="Valor Anual do Seguro"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </ng-template>
            </p-step-panel>

            <p-step-panel [value]="2">
              <ng-template #content>
                <app-search-bar
                  [filters]="[]"
                  [sortFields]="[]"
                  primaryBtnLabel="Adicionar Fase da Formação"
                  (onPrimaryBtnClick)="
                    visible = true; currentEditIndex = null; resetForm()
                  "
                  (formValueChange)="handleFormValueChange($event)"
                ></app-search-bar>

                <div class="row">
                  <ng-container
                    *ngIf="pagination.data?.length; else emptyTemplate"
                  >
                    <app-table
                      [pagination]="pagination"
                      [columns]="columns"
                      [actions]="actions"
                      (pageChange)="onPageChange($event)"
                      (actionSelected)="onActionSelected($event)"
                    ></app-table>
                  </ng-container>
                  <ng-template #emptyTemplate>
                    <div class="no-data">
                      <app-data-void
                        titulo="Nehuma Fase da Formação encontrada"
                        descricao="Clique em Adicionar Fase de Formação para criar uma."
                      ></app-data-void>
                    </div>
                  </ng-template>
                </div>
              </ng-template>
            </p-step-panel>
          </div>
        </p-step-panels>
      </p-stepper>
      <div class="w-full p-4" style="margin-top: -25px">
        <div class="flex justify-content-between flex-wrap gap-4 w-full">
          <p-button
            *ngIf="activeStep > 1"
            (click)="previousStep()"
            label="Voltar"
            severity="secondary"
          />

          <p-button
            *ngIf="activeStep < 2"
            type="button"
            label="Próximo"
            severity="secondary"
            (click)="nextStep()"
          />

          <button
            pButton
            type="submit"
            severity="primary"
            [disabled]="isLoading"
          >
            <ng-container *ngIf="isLoading; else saveLabel">
              <i class="pi pi-spin pi-spinner"></i> Guardando...
            </ng-container>
            <ng-template #saveLabel>{{
              isEditMode ? "Actualizar" : "Guardar"
            }}</ng-template>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- MODAL PARA ADICIONAR AS FASES DE FORMAÇÃO -->

<p-dialog
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '720px', maxHeight: '100%', padding: '1.25rem' }"
  [contentStyle]="{ overflow: 'hidden' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template #headless>
    <div class="custom-modal-layout">
      <!-- HEADER -->
      <div class="modal-header">
        <div class="icon">
          <img src="icons/plus-circle.svg" alt="Icon" />
        </div>
        <span class="title">Adicionar Fase de Formação</span>
        <p-button
          icon="pi pi-times"
          class="close-btn"
          [rounded]="true"
          [text]="true"
          (onClick)="visible = false"
        >
        </p-button>
      </div>

      <!-- BODY (SCROLL) -->
      <div class="modal-body">
        <form [formGroup]="institutionForm">
          <div class="p-fluid grid">
            <!-- FASE -->
            <div class="field col-6">
              <label for="fase">Fase</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="fase"
                formControlName="faseCursoID"
                [options]="listaFases"
                optionLabel="designacao"
                optionValue="id"
                placeholder="Seleccione a fase de formação"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  institutionForm.get('faseCursoID')?.touched &&
                  institutionForm.get('faseCursoID')?.errors?.['required']
                "
              >
                A fase de formação é obrigatória.
              </small>
            </div>

            <!-- INSTITUIÇÃO -->
            <div class="field col-6">
              <label for="instituicao">Instituição de Ensino</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="instituicao"
                [options]="educationalInstitution"
                optionLabel="nome"
                optionValue="id"
                formControlName="instituicao"
                placeholder="Seleccione uma instituição de ensino"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  institutionForm.get('instituicao')?.touched &&
                  institutionForm.get('instituicao')?.errors?.['required']
                "
              >
                Instituição de Ensino é obrigatória.
              </small>
            </div>

            <!-- UNIDADE ORGÂNICA -->
            <div class="field col-6">
              <label for="unidadeOrganica">Unidade Orgânica</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="unidadeOrganica"
                formControlName="unidadeOrganicaID"
                [options]="listaUnidadesOrganicas"
                optionLabel="designacao"
                optionValue="id"
                placeholder="Seleccione a unidade orgânica"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  institutionForm.get('unidadeOrganicaID')?.touched &&
                  institutionForm.get('unidadeOrganicaID')?.errors?.['required']
                "
              >
                A unidade orgânica é obrigatória.
              </small>
            </div>

            <!-- CURSO -->
            <div class="field col-6">
              <label for="curso">Curso</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="curso"
                formControlName="instituicaoCursoID"
                [options]="instituicaoCursoList"
                optionLabel="nome"
                optionValue="id"
                placeholder="Seleccione o curso"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  institutionForm.get('instituicaoCursoID')?.touched &&
                  institutionForm.get('instituicaoCursoID')?.errors?.[
                    'required'
                  ]
                "
              >
                Curso é obrigatório.
              </small>
            </div>

            <!-- ANO CURRICULAR -->
            <div
              class="field col-12"
              *ngIf="anoCurricularOptions?.length; else anoManual"
            >
              <label for="anoCurricular">Ano Curricular</label>
              <p-select
                id="anoCurricular"
                [options]="anoCurricularOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="anoCurricular"
                placeholder="Seleccione o ano curricular"
                appendTo="body"
                class="w-full"
              >
              </p-select>
            </div>

            <ng-template #anoManual>
              <div class="field col-12">
                <label for="anoCurricular">Ano Curricular</label>
                <p-inputnumber
                  id="anoCurricular"
                  formControlName="anoCurricular"
                  [min]="1"
                  [max]="6"
                  [useGrouping]="false"
                  placeholder="Informe o ano (1–6)"
                  class="w-full"
                >
                </p-inputnumber>
                <small class="help"
                  >Sem plano curricular — informe manualmente.</small
                >
              </div>
            </ng-template>

            <!-- DATAS -->
            <div class="field col-6">
              <label>Data de Início</label>
              <p-datepicker
                appendTo="body"
                [showIcon]="true"
                formControlName="dataInicio"
                dateFormat="dd/mm/yy"
                class="w-full"
              ></p-datepicker>
            </div>

            <div class="field col-6">
              <label>Data de Fim</label>
              <p-datepicker
                appendTo="body"
                [showIcon]="true"
                formControlName="dataFim"
                dateFormat="dd/mm/yy"
                class="w-full"
              ></p-datepicker>
            </div>

            <!-- DURAÇÃO -->
            <div class="field col-6">
              <label>Duração</label>
              <input
                pInputText
                formControlName="duracao"
                placeholder="Duração"
                class="w-full"
              />
            </div>

            <!-- ESTADO -->
            <div class="field col-6">
              <label>Estado da fase</label>
              <p-select
                [options]="aproveitamentoOptions"
                optionLabel="designacao"
                optionValue="id"
                formControlName="aproveitamento"
                placeholder="Seleccione o estado"
                class="w-full"
              >
              </p-select>
            </div>

            <!-- BOTÕES -->
            <div
              class="modal-footer w-full d-flex justify-content-between gap-3 mt-4"
            >
              <button
                pButton
                type="button"
                label="Cancelar"
                class="p-button-outlined"
                (click)="visible = false; resetForm()"
              ></button>

              <button
                pButton
                type="button"
                [label]="
                  currentEditIndex != null
                    ? 'Editar'
                    : 'Adicionar Fase da Formação'
                "
                class="p-button-primary"
                (click)="addInstituicao()"
              ></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- MODAL PARA Editar A MATRICULA DA FASE DE FORMAÇÃO -->

<p-dialog
  [modal]="true"
  [(visible)]="visibleEditMatricula"
  [style]="{ width: '720px', maxHeight: '100%', padding: '1.25rem' }"
  [contentStyle]="{ overflow: 'hidden' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template #headless>
    <div class="custom-modal-layout">
      <!-- HEADER -->
      <div class="modal-header">
        <div class="icon">
          <img src="icons/plus-circle.svg" alt="Icon" />
        </div>
        <span class="title">Editar matricula</span>
        <p-button
          icon="pi pi-times"
          class="close-btn"
          [rounded]="true"
          [text]="true"
          (onClick)="visibleEditMatricula = false"
        >
        </p-button>
      </div>

      <!-- BODY (SCROLL) -->
      <div class="modal-body">
        <form [formGroup]="editMatriculaForm">
          <div class="p-fluid grid">
            <!-- FASE -->
            <div class="field col-6">
              <label for="fase">Fase</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="fase"
                formControlName="faseCursoID"
                [options]="listaFases"
                optionLabel="designacao"
                optionValue="id"
                placeholder="Seleccione a fase de formação"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  editMatriculaForm.get('faseCursoID')?.touched &&
                  editMatriculaForm.get('faseCursoID')?.errors?.['required']
                "
              >
                A fase de formação é obrigatória.
              </small>
            </div>

            <!-- INSTITUIÇÃO -->
            <div class="field col-6">
              <label for="instituicao">Instituição de Ensino</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="instituicao"
                [options]="educationalInstitution"
                optionLabel="nome"
                optionValue="id"
                formControlName="instituicao"
                placeholder="Seleccione uma instituição de ensino"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  editMatriculaForm.get('instituicao')?.touched &&
                  editMatriculaForm.get('instituicao')?.errors?.['required']
                "
              >
                Instituição de Ensino é obrigatória.
              </small>
            </div>

            <!-- UNIDADE ORGÂNICA -->
            <div class="field col-6">
              <label for="unidadeOrganica">Unidade Orgânica</label>
              <p-select
                [filter]="true"
                [showClear]="true"
                appendTo="body"
                id="unidadeOrganica"
                formControlName="unidadeOrganicaID"
                [options]="listaUnidadesOrganicas"
                optionLabel="designacao"
                optionValue="id"
                placeholder="Seleccione a unidade orgânica"
                class="w-full"
              >
              </p-select>
              <small
                class="error-message"
                *ngIf="
                  editMatriculaForm.get('unidadeOrganicaID')?.touched &&
                  editMatriculaForm.get('unidadeOrganicaID')?.errors?.[
                    'required'
                  ]
                "
              >
                A unidade orgânica é obrigatória.
              </small>
            </div>

            <!-- CURSO -->
            <div class="field col-6">
              <label for="curso">Curso</label>
              <input
                pInputText
                id="instituicaoCursoID"
                formControlName="instituicaoCursoID"
                class="w-full"
              />
              <small
                class="error-message"
                *ngIf="
                  editMatriculaForm.get('instituicaoCursoID')?.touched &&
                  editMatriculaForm.get('instituicaoCursoID')?.errors?.[
                    'required'
                  ]
                "
              >
                Curso é obrigatório.
              </small>
            </div>

            <!-- ANO CURRICULAR -->

            <div
              class="field col-12"
              *ngIf="anoCurricularOptions?.length; else anoManual"
            >
              <label for="anoCurricular">Ano Curricular</label>
              <p-select
                id="anoCurricular"
                [options]="anoCurricularOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="anoCurricular"
                placeholder="Seleccione o ano curricular"
                appendTo="body"
                class="w-full"
              >
              </p-select>
            </div>

            <ng-template #anoManual>
              <div class="field col-12">
                <label for="anoCurricular">Ano Curricular</label>
                <p-inputnumber
                  id="anoCurricular"
                  formControlName="anoCurricular"
                  [min]="1"
                  [max]="6"
                  [useGrouping]="false"
                  placeholder="Informe o ano (1–6)"
                  class="w-full"
                >
                </p-inputnumber>
                <small class="help"
                  >Sem plano curricular — informe manualmente.</small
                >
              </div>
            </ng-template>

            <!-- DATAS -->
            <div class="field col-6">
              <label>Data de Início</label>
              <p-datepicker
                appendTo="body"
                [showIcon]="true"
                formControlName="dataInicio"
                dateFormat="dd/mm/yy"
                class="w-full d-grid"
              ></p-datepicker>
            </div>

            <div class="field col-6">
              <label>Data de Fim</label>
              <p-datepicker
                appendTo="body"
                [showIcon]="true"
                formControlName="dataFim"
                dateFormat="dd/mm/yy"
                class="w-full d-grid"
              ></p-datepicker>
            </div>

            <!-- DURAÇÃO -->
            <div class="field col-6">
              <label>Duração</label>
              <input
                pInputText
                formControlName="duracao"
                placeholder="Duração"
                class="w-full"
              />
            </div>

            <!-- ESTADO -->
            <div class="field col-6">
              <label>Estado da fase</label>
              <p-select
                [options]="aproveitamentoOptions"
                optionLabel="designacao"
                optionValue="id"
                formControlName="aproveitamento"
                placeholder="Seleccione o estado"
                class="w-full"
              >
              </p-select>
            </div>

            <!-- BOTÕES -->
            <div
              class="modal-footer w-full d-flex justify-content-between gap-3 mt-4"
            >
              <button
                pButton
                type="button"
                label="Cancelar"
                class="p-button-outlined"
                (click)="visibleEditMatricula = false"
              ></button>

              <button
                pButton
                type="button"
                label="Actualizar matricula"
                class="p-button-primary"
                (click)="updateAnoMatricula()"
              ></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>